<rd-star-banner></rd-star-banner>
<ng-container *ngIf="rewardsPreference$ | async as rp">
  <div class="rewards-preference-container pt-6 pb-5">
    <div class="rewards-preference">
      <rd-shared-alert
        alertTheme="success"
        icon="linked-carrier-success"
        *ngIf="rewardsPreferenceCreateSuccess | async">
        <span class="m-0 h-full w-full typo-text-mobile lg:typo-text-desktop">
          You have successfully selected your Status Airline!
        </span>
      </rd-shared-alert>
      <h2 class="lg:typo-heading-2-desktop">Your Status Airline</h2>
      <div
        class="info item-start flex flex-col gap-8 p-4 lg:flex-row lg:items-center lg:py-[28px] lg:px-[40px]">
        <div class="flex grow items-start gap-8 lg:items-center">
          <ng-container *ngIf="rewardsPreferenceLoyaltyProgram$ | async as lp">
            <img
              [src]="lp.benefitCapability.logoUrl"
              alt=""
              class="mt-3 lg:mt-0" />
          </ng-container>
          <div class="flex flex-grow flex-col justify-between gap-[10px]">
            <div class="lp-name font-bold">
              {{ rp.membership.loyaltyProgramName }}
            </div>
            <div>{{ rp.membership.number }}</div>
            <a
              type="button"
              class="button-reset link-text change-icon inline-flex w-[110px] items-center gap-2 p-4 focus-link"
              [routerLink]="'select-carrier/loyalty-programs/'">
              <rd-shared-icon
                class="inline-flex"
                iconSymbol="icon-change"
                iconTheme="primary"></rd-shared-icon>
              <span
                class="text-[#c2a357] typo-text-emphasis-1-desktop hover:text-[#ceb579]"
                >Change</span
              >
            </a>
          </div>
        </div>
        <div class="h-[40px] w-full lg:w-[200px]">
          <rd-shared-button
            roleType="button"
            buttonType="button"
            buttonTheme="primary"
            buttonText="Convert Points"
            [redirectURL]="
              '/transfer/checkout/' + rp.membership.loyaltyProgramId
            ">
          </rd-shared-button>
        </div>
      </div>

      <aside class="disclaimer-container mb-3 flex flex-row lg:mb-14">
        <rd-shared-icon
          class="disclaimer-icon mt-6"
          [iconSymbol]="'icon-disclaimer-info'"
          [iconTheme]="'black'"></rd-shared-icon>

        <p class="disclaimer-content mt-5 mb-0 ml-2">
          In any qualification year, you may only claim status through a single
          Status Airline. If you change your Status Airline after you have
          claimed Star Alliance Silver or Star Alliance Gold Status, the change
          will only be effective for any status you may receive in the following
          qualification year. You may manage your Status Airline in the settings
          of your Star Alliance Rewards Account at any time.
        </p>
      </aside>
    </div>
  </div>
</ng-container>
<div class="container gap-[80px] pb-[40px] lg:grid lg:py-[80px]">
  <article
    class="homepage-article flex flex-col items-center justify-between lg:flex-row">
    <div
      class="homepage-article-content flex-col items-start justify-center lg:flex lg:w-[480px]">
      <h2 class="lg:my-0 lg:typo-heading-2-desktop">
        {{ 'wl.star.homepage.earn_points' | translate }}
      </h2>
      <img
        *ngIf="isMobileViewport"
        class="w-full lg:hidden"
        [src]="introductionImages.earnPointsMobileUrl"
        alt="" />
      <p class="mb-2">
        Through the
        <rd-shared-link
          text="HSBC Star Alliance Credit Card"
          path="https://www.hsbc.com.au/credit-cards/products/star-alliance/"
          [showIcon]="false"
          [isTargetBlank]="true">
        </rd-shared-link
        >, you may earn Star Alliance Points<sup>1</sup> and, if you meet the
        respective spending threshold<sup>3</sup>, achieve Star Alliance Silver
        or Gold status entitling you to premium customer benefits and
        privileges<sup>3</sup>
        when you fly with any Star Alliance member airline.
      </p>

      <p class="my-2">
        Earn up to 1 Star Alliance Point per $1 spent on eligible purchases<sup
          >1</sup
        >
        when using the
        <rd-shared-link
          text="HSBC Star Alliance Credit Card"
          path="https://www.hsbc.com.au/credit-cards/products/star-alliance/"
          [showIcon]="false"
          [isTargetBlank]="true">
        </rd-shared-link
        ><sup>5</sup>.
      </p>
      <p class="mt-2 mb-0">
        If you achieve Star Alliance Silver or Gold Status<sup>3</sup>, your
        status will be granted in the Frequent Flyer Program of a Star Alliance
        member airline participating in Star Alliance Rewards – just select your
        Status Airline on registration.
      </p>
    </div>
    <img
      *ngIf="!isMobileViewport"
      class="hidden lg:block lg:w-[480px]"
      [src]="introductionImages.earnPointsUrl"
      alt="" />
  </article>

  <article
    class="homepage-article flex flex-col items-center justify-between lg:flex-row-reverse">
    <div
      class="homepage-article-content flex-col items-start justify-center lg:flex lg:w-[480px]">
      <h2 class="lg:my-0 lg:typo-heading-2-desktop">
        {{ 'wl.star.homepage.use_points' | translate }}
      </h2>
      <img
        *ngIf="isMobileViewport"
        class="w-full lg:hidden"
        [src]="introductionImages.redeemPointsMobileUrl"
        alt="" />
      <p class="mb-2">
        Star Alliance Points can be converted for award miles/points in your
        chosen Star Alliance member airline Frequent Flyer Program subject to
        any applicable transaction limits.<sup>2</sup>
      </p>
      <p class="my-2">
        Provided you are a member of the program, you have the flexibility to
        convert your Star Alliance Points whenever you want into any of the
        participating member airlines, <sup>2</sup> regardless of which one you
        selected as your Status Airline.
      </p>
      <p class="mb-2">
        Once you log in to your Star Alliance Rewards Account, you can see the
        current rate for converting Star Alliance Points to the award
        miles/point of the participating member airlines.
      </p>

      <div class="mt-4 w-full lg:w-[300px]">
        <rd-shared-button
          [buttonContent]="transferYourPoints"
          [buttonTheme]="'primary'"
          [redirectURL]="'/transfer'">
          <ng-template #transferYourPoints>
            <span>Convert your Points now</span>
          </ng-template>
        </rd-shared-button>
      </div>
    </div>
    <img
      *ngIf="!isMobileViewport"
      class="hidden lg:block lg:w-[480px]"
      [src]="introductionImages.redeemPointsUrl"
      alt="" />
  </article>
</div>
<hr class="homepage-breakline" />
<div class="homepage-members-container pt-2 pb-8 lg:py-10">
  <div class="container">
    <h2
      class="mx-auto w-[340px] text-center lg:w-auto lg:typo-heading-2-desktop">
      {{ 'wl.star.homepage.participating_members' | translate }}
    </h2>
    <ul class="grid list-none grid-cols-2 gap-0 px-0 lg:grid-cols-5">
      <li
        *ngFor="let member of saMemberAirlines"
        class="flex items-center justify-center py-6">
        <img
          class="homepage-brand-logo"
          [src]="member.imageUrl"
          [alt]="member.name" />
      </li>
    </ul>
  </div>
</div>
<div class="homepage-benefit-container pt-2 pb-8 lg:py-10">
  <div class="container">
    <h2 class="text-center lg:typo-heading-2-desktop">
      {{ 'wl.star.homepage.member_benefits' | translate }}
    </h2>
    <ul
      class="homepage-list-benefits mb-4 grid list-none grid-cols-2 gap-0 px-0 lg:mb-8 lg:grid-cols-4">
      <li
        class="flex flex-col items-center justify-start px-4 py-6"
        *ngFor="let benefit of saBenefits">
        <img class="h-[40px] lg:h-[50px]" [src]="benefit.imageUrl" alt="" />
        <span
          class="mt-4 text-center typo-text-mobile lg:typo-text-desktop"
          [innerHtml]="benefit.name"></span>
      </li>
    </ul>
    <p class="rd-shared-link star-shared-link text-center">
      <a
        href="https://www.staralliance.com/en/recognition"
        target="_blank"
        rel="noreferrer"
        class="link mx-auto inline-flex items-center no-underline focus-link"
        [attr.aria-label]="'wl.star.homepage.find_out_more_alt' | translate">
        <span class="link-text">
          {{ 'wl.star.homepage.find_out_more' | translate }}
        </span>
        <rd-shared-icon
          class="ml-2 h-[16px] w-[16px]"
          [iconSymbol]="'icon-chevron-right'"
          [iconTheme]="'link'"></rd-shared-icon>
      </a>
    </p>
  </div>
</div>
